import { render, staticRenderFns } from "./PendingDocs.vue?vue&type=template&id=4f2acdda"
import script from "./PendingDocs.vue?vue&type=script&lang=js"
export * from "./PendingDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports